import type {OfferingType} from './offering';
const types = new Set<OfferingType>(['physical','software','service','mixed','unknown']);
export function detectedOfferingType(detected: unknown, selected: unknown = 'unknown'): OfferingType {
 const valid=(value:unknown):OfferingType=>typeof value==='string'&&types.has(value as OfferingType)?value as OfferingType:'unknown';
 const manual=valid(selected);return manual!=='unknown'?manual:valid(detected);
}
/** Aggregate actual sold offerings, not the existence of a companion app or recurring billing. */
export function brandOfferingType(data: Record<string,unknown>): OfferingType {
 const sold=new Set<OfferingType>();
 if(Array.isArray(data.sold_offerings))for(const item of data.sold_offerings.slice(0,30)){
  if(!item||typeof item!=='object'||typeof item.name!=='string'||!item.name.trim()||typeof item.evidence!=='string'||!item.evidence.trim())continue;
  const type=detectedOfferingType(item.type);if(type!=='unknown')sold.add(type);
 }
 if(sold.has('mixed')||(sold.has('physical')&&(sold.has('software')||sold.has('service'))))return 'mixed';
 if(sold.size===1)return [...sold][0];
 return detectedOfferingType(data.offering_type);
}
export function suggestedOfferingType(current: OfferingType, detected: unknown): OfferingType {
 return detectedOfferingType(detected,current);
}
export function offeringAnalysisMediaAllowed(type: unknown): boolean {
 return type!=='software'&&type!=='service';
}
